import  Mock from 'mockjs'
import test from "./test"
import tree from "./tree"
import collectorManagement from './collectorManagement'
import eqpMonitor from './eqpMonitor'
import dataPlatform from './dataPlatform'
import historyData from './historyData'
import realTimeDataMointor from './realTimeDataMointor'

// 修复在使用 MockJS 情况下，设置 withCredentials = true，且未被拦截的跨域请求丢失 Cookies 的问题
// https://github.com/nuysoft/Mock/issues/300
Mock.XHR.prototype.proxy_send = Mock.XHR.prototype.send
Mock.XHR.prototype.send = function() {
  if (this.custom.xhr) {
    this.custom.xhr.withCredentials = this.withCredentials || false
  }
  this.proxy_send(...arguments)
}

Mock.setup({
  timeout: '200-600'
})

// test(Mock)
// tree(Mock)
// collectorManagement(Mock)
// eqpMonitor(Mock)
// dataPlatform(Mock)
// historyData(Mock)
// realTimeDataMointor(Mock)
export default Mock
